import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {IPowerSource, IPowerSourceLocation, IYear} from "../../../../data/data";
import {getPowerSourceAtLocation, isPowerSourceLastOfType} from "../../../../store/reducers/powerSources";
import {logStore} from "../../../../store/store";
import {setSelectedLocation} from "../../../../store/actions/locations";
import {getHighlightLocation, isLocationHighlighted} from "../../../../store/reducers/highlightLocation";
import {getDraggingPowerSource} from "../../../../store/reducers/draggingPowerSource";
import {isLocationValidForDraggingPowerSource} from "../../../../store/reducers/location";
import {showNextOutageQuestion} from "../../../../store/actions/questions/questions";
import {isPowerSourceDamaged} from '../../../../store/reducers/power-sources/damage';
import {repairDamageAtLocation} from '../../../../store/actions/power-sources/damage';
import {isPowerSourceDeprecated} from '../../../../store/reducers/power-sources/deprecate';
import {getYearData, getYearIndex} from '../../../../store/reducers/year';
import {removePowerSourceAtLocation} from '../../../../store/actions/powerSources';

interface IMapLocationProps extends IPowerSourceLocation
{
    location_id: number;
    power_source: IPowerSource;
    is_damaged: boolean;
    is_deprecated: boolean;
    is_highlight: boolean;
    is_valid: boolean;
    dragging_power_source: IPowerSource;
    year: IYear;
    is_last: boolean;
    setSelectedLocation: (location_id: number) => void;
    showQuestion: () => void;
    repairDamageAtLocation: (location_id: number) => void;
    removePowerSourceAtLocation: (location_id: number) => void;
}

import './MapLocation.scss';



class MapLocation extends React.Component<IMapLocationProps, null>
{
    constructor(public props: IMapLocationProps)
    {
        super(props);
    }


    /**
     * when the location is clicked, show either the add power source popup or source details modal
     */
    onClick = (event: React.MouseEvent<HTMLElement>) =>
    {
        if ((event.target as HTMLElement).classList.contains('delete')) return;

        const {is_damaged, repairDamageAtLocation, power_source, setSelectedLocation, location_id} = this.props;

        if (is_damaged) return repairDamageAtLocation(location_id);

        if (power_source) setSelectedLocation(location_id);

        //  TODO  investigate Pose - https://popmotion.io/pose/learn/get-started/
    };


    getBackgroundImage = () : string =>
    {
        const {power_source} = this.props;

        if (! power_source) return null;

        const {id} = power_source;

        let icon: string;
        const {type} = this.props;

        // console.group('getBackgroundImage');
        // console.log('id', id);
        // console.log('type', type);
        // console.groupEnd();

        switch (id)
        {
            case 'wind-sea':
            {
                // console.group('getBackgroundImage');
                // console.log('id', id);
                // console.log('type', type);
                // console.groupEnd();

                icon = id;

                break;
            }

            default:
            {
                icon = id;

                break;
            }
        }

        return `url(./img/game/map-power-sources/${icon}@2x.png)`;
    };


    getTooltipText = () =>
    {
        const {power_source, is_valid, type, dragging_power_source, is_damaged, is_deprecated, year} = this.props;

        // if (power_source && power_source.id === 'other')
        // {
        //     return '';
        // }

        // console.group('getTooltipText');
        // console.log('power_source', power_source);
        // console.log('is_damaged', is_damaged);
        // console.log('is_deprecated', is_deprecated);
        // console.groupEnd();

        if ((year.year === 2020 || year.year === 2024))
        {
            return null;
        }

        if (! this.canDelete() && power_source && power_source.id !== 'other' && ! is_damaged && ! is_deprecated)
        {
            return "<span style='text-transform: none;'>Oops!<br/>You can’t remove this power source from your map,<br/>as it needs to be in your 2032 energy mix.<br/>(*Clue alert!*).</span>";
        }

        if (! is_valid) return dragging_power_source['requirement-reason'];

        if (power_source) return power_source.label;

        return type;
    };


    getIconStyleName = () : string =>
    {
        const {year:year_data, is_damaged, is_deprecated} = this.props;
        const {year} = year_data;

        if (is_deprecated) return 'icon-deprecated';
        // if (is_damaged) return 'icon-damaged';
        if (is_damaged) return year !== 2024 ? 'icon-damaged' : 'icon-boost';

        return 'icon-enabled';
    };


    // getIconStyleName = () : string =>
    // {
    //     const {year, is_valid} = this.props;
    //
    //     if (is_valid) return 'location-icon';
    //
    //     return year.year !== 2024 ? 'invalid-icon' : 'invalid-icon';
    // };


    canDelete = () =>
    {
        const {power_source, year, is_last} = this.props;
        const {removable} = power_source || {} as any;

        return power_source && removable !== false && ! is_last && ! (year.year === 2020 || year.year === 2024)
    };


    render()
    {
        const {position, power_source, is_damaged, location_id, is_valid, removePowerSourceAtLocation, is_last} = this.props;
        const {removable} = power_source || {} as any;

        return <div
                    styleName={! power_source ? 'empty' : 'populated'}
                    style={{
                        top: `${position[1]}%`,
                        left: `${position[0]}%`,
                        // opacity: is_highlight ? 0.5 : 1
                    }}
                    onClick={this.onClick}>

            <div
                styleName={is_valid ? 'location-icon' : 'invalid-icon'}
                style={{
                    backgroundImage: this.getBackgroundImage()
                }}/>

            <div styleName={this.getIconStyleName()}/>

            {this.getTooltipText() &&
            <span styleName={'tooltip'} dangerouslySetInnerHTML={{ __html: this.getTooltipText() }} />}

            {this.canDelete() &&
            <span
                styleName={'delete-button'}
                className={'delete'}
                onClick={() => removePowerSourceAtLocation(location_id)}>

                <img className={'delete'} src={'img/game/map-location/cross.png'} />

            </span>}

        </div>
    }
}


const mapStateToProps = (state, props) =>
{
    return {
        power_source: getPowerSourceAtLocation(state, props),
        is_damaged: isPowerSourceDamaged(state, props),
        is_deprecated: isPowerSourceDeprecated(state, props),
        is_highlight: isLocationHighlighted(state, props),
        is_valid: isLocationValidForDraggingPowerSource(state, props),
        is_last: isPowerSourceLastOfType(state, props),
        dragging_power_source: getDraggingPowerSource(state),
        year: getYearData(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {
        setSelectedLocation: (location_id: number) => dispatch(setSelectedLocation(location_id)),
        repairDamageAtLocation: (location_id: number) => dispatch(repairDamageAtLocation(location_id)),
        showQuestion: () => dispatch(showNextOutageQuestion()),
        removePowerSourceAtLocation: (location_id: number) => dispatch(removePowerSourceAtLocation(location_id)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MapLocation);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/map/MapLocation.tsx